import React, { useState , useEffect } from "react";
import * as Icon from "react-bootstrap-icons";
import { milestoneService } from '../../service/mileStone.service'; // ✅ Import service

const Progress: React.FC<{}> = () => {
 
// useEffect(() => {
//   const fetchMilestone = async () => {
//     try {
//       console.log("Progress: calling milestoneService.getAll()");
//       const milestones = await milestoneService.getAll(); 

//       if (!milestones || milestones.length === 0) {
//         setCurrentStep(0);
//         setProgress(0);
//         return;
//       }

//       const lastCompletedIndex = milestones
//         .map((m) => m.isCompleted)
//         .lastIndexOf(true);

//       if (lastCompletedIndex >= 0) {
//         setCurrentStep(lastCompletedIndex);
//         setProgress((lastCompletedIndex / (milestones.length - 1)) * 100);
//       } else {
//         setCurrentStep(0);
//         setProgress(0);
//       }
//     } catch (err) {
//       console.error("Progress: error fetching milestones:", err);
//     }
//   };

//   fetchMilestone();
// }, []);


useEffect(() => {
  const fetchMilestone = async () => {
    try {
      console.log("Fetching milestone progress...");
      const milestones = await milestoneService.getAll();

      if (!milestones || milestones.length === 0) {
        setCurrentStep(0);
        setProgress(0);
        return;
      }

      const lastCompletedIndex = milestones
        .map((m) => m.isCompleted)
        .lastIndexOf(true);

      setCurrentStep(lastCompletedIndex >= 0 ? lastCompletedIndex : 0);
      setProgress(
        lastCompletedIndex >= 0
          ? (lastCompletedIndex / (milestones.length - 1)) * 100
          : 0
      );
    } catch (error) {
      console.error("Error fetching milestone:", error);
    }
  };

  fetchMilestone(); // initial fetch

  const interval = setInterval(fetchMilestone, 5000); // re-fetch every 5 seconds

  return () => clearInterval(interval); // cleanup
}, []);

const [currentStep, setCurrentStep] = useState(0);
  const [progress, setProgress] = useState(10);

  // use the icon component (not a JSX element) so we can render with props
  const steps: {
    icon: React.ComponentType<{ size?: number }>;
    label: string;
    value: number;
  }[] = [
    { icon: Icon.House, label: "Properties Allocated", value: 0 },
    { icon: Icon.Heart, label: "Shortlisted", value: 1 },
    { icon: Icon.FileText, label: "Request Reservation", value: 2 },
    { icon: Icon.Clock, label: "Booking In Progress", value: 3 },
    { icon: Icon.CheckCircle, label: "Booking Completed", value: 4 },
  ];
console.log("Current Step:", currentStep);
  const handleStepClick = (stepValue: number) => {
    setCurrentStep(stepValue);
    setProgress((stepValue / (steps.length - 1)) * 100);
  };

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      const nextStep = currentStep + 1;
      handleStepClick(nextStep);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      const prevStep = currentStep - 1;
      handleStepClick(prevStep);
    }
  };
  return (
    <>
      <div
        className="booking-stepper-container"
        style={{
          marginBottom: "0",
          transform: "scale(0.85)",
          transformOrigin: "center",
          width: "117.65%",
          marginTop: "-8px",
        }}
      >
        <div className="stepper-wrapper">
          {/* Background Line */}
          <div className="stepper-line">
            <div
              className="stepper-line-active"
              style={{ width: `${(currentStep / (steps.length - 1)) * 100}%` }}
            />
          </div>

          {/* Steps */}
          {steps.map((step, index) => {
            const StepIcon = step.icon;
            const isActive = index === currentStep;
            const isCompleted = index < currentStep;

            return (
              <div key={index} className="stepper-step">
                <div
                  className={`stepper-icon-container ${
                    isActive ? "active" : ""
                  } ${isCompleted ? "completed" : ""}`}
                  // onClick={() => {
                  //   setCurrentStep(index);
                  //   setProgress((index / (steps.length - 1)) * 100);
                  // }}
                >
                  <StepIcon size={16} />
                </div>
                <span
                  className={`stepper-label ${isActive ? "active" : ""}`}
                  style={{ fontSize: "0.65rem" }}
                >
                  {step.label}
                </span>
              </div>
            );
          })}
        </div>

        {/* Progress Bar */}
        <div
          className="progress-bar-container"
          style={{ height: "8px", marginTop: "0.3rem", borderRadius: "4px" }}
        >
          <div
            className="progress-bar"
            style={{
              width: `${progress}%`,
              height: "8px",
              borderRadius: "4px",
            }}
          >
            <span
              className="progress-text"
              style={{ fontSize: "0.6rem", top: "-1.1rem" }}
            >
              {Math.round(progress)}%
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Progress;
